import firebase from 'firebase';

let config = {
  apiKey: "AIzaSyA52T1JUlhnI15peglPuEofBk7OUkxpMyk",
  authDomain: "mindaidapp.firebaseapp.com",
  databaseURL: "https://mindaidapp.firebaseio.com",
  projectId: "mindaidapp",
  storageBucket: "mindaidapp.appspot.com",
  messagingSenderId: "415113838772"
};


export default function() {
  if (!firebase.apps.length) {
    return firebase.initializeApp(config);
  } else {
    return firebase.apps[0];
  }
};



// WEBPACK FOOTER //
// ./src/firebase.js